import axios from 'axios';
import {AuthResponse} from "../models/response/AuthResponse";

export const API_URL = 'https://containera.online/api/v1';

const frontendVersion = Array.from(document.scripts)
    .map(script => script.src.match(/\/main\.([a-z0-9]+)\.js(?:\?|$)/i)?.[1])
    .find(Boolean) ?? 'development';

const frontendClientId = (() => {
    const storageKey = 'frontend-client-id';
    const saved = localStorage.getItem(storageKey);
    if (saved) {
        return saved;
    }

    const generated = globalThis.crypto?.randomUUID?.()
        ?? `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(storageKey, generated);
    return generated;
})();

const $api = axios.create({
    withCredentials: false,
    baseURL: API_URL,

})



$api.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
    config.headers['X-Frontend-Auto-Update'] = '1'
    config.headers['X-Frontend-Version'] = frontendVersion
    config.headers['X-Frontend-Client-Id'] = frontendClientId
    return config;
});

$api.interceptors.response.use((config) => {
    return config;
}, async (error) => {
    const originalRequest = error.config;
    if(error.response?.status === 401 && error.config && !error.config._isRetry){
        originalRequest._isRetry = true;
        try {
            const response = await axios.get<AuthResponse>(`${API_URL}/refresh`, {withCredentials:true})
            localStorage.setItem('token', response.data.accessToken);
            return $api.request(originalRequest);
        } catch (e){
            localStorage.removeItem('token');
            window.location.assign('/');
        }
    }
    return Promise.reject(error);
});

export default $api;
